import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-prices-and-packages',
  templateUrl: './new-prices-and-packages.component.html',
  styleUrls: ['./new-prices-and-packages.component.scss']
})
export class NewPricesAndPackagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
